import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'

import { httpOk, GET } from 'helpers/api'
import { formatMoney, returnSign } from "helpers/helpers"

function SummaryExpense({ setActiveModal, filterData }) {
	const { t } = useTranslation()

	const [data, setData] = useState([])

	async function searchWithFilter() {
		var filterUrl = "/report-summary-loyalty"
		var urlParams = ""

		if (filterData.pos_id)
			urlParams += returnSign(urlParams) + 'pos_id=' + filterData.pos_id
		if (filterData.start_date)
			urlParams += returnSign(urlParams) + 'start_date=' + filterData.start_date
		if (filterData.end_date)
			urlParams += returnSign(urlParams) + 'end_date=' + filterData.end_date

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) setData(response.data)
	}

	useEffect(() => {
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<Modal
				show={true}
				animation={false}
				centered
				size="md"
				onHide={() => setActiveModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>
						{t('loyalty')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="table-responsive table-fixed" style={{ 'height': '500px', 'overflow': 'auto' }}>
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '30%' }}>{t('phone')}</th>
									<th style={{ 'width': '30%' }}>{t('name')}</th>
									<th className="text-end" style={{ 'width': '40%' }}>{t('amount')}</th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr key={index}>
										<td className="text-center">{index + 1}</td>
										<td>{item.phone1}</td>
										<td>{item.first_name}</td>
										<td className="text-end">{formatMoney(item.loyalty_amount_out)}</td>
									</tr>
								))}
								<tr>
									<td></td>
									<td><b>{t('total')}</b></td>
									<td></td>
									<td className="text-end"><b>{formatMoney(data.total_amount)}</b></td>
								</tr>
							</tbody>
						</table>
					</div>
				</Modal.Body>
			</Modal>
		</>
	)
}

export default SummaryExpense